export default "__VITE_ASSET__BDoG1kTO__"